import { render, staticRenderFns } from "./OrderCreatorProduct.vue?vue&type=template&id=3a1e2d5a&"
import script from "./OrderCreatorProduct.vue?vue&type=script&lang=js&"
export * from "./OrderCreatorProduct.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreatorProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports